import cloneSnakeCaseProperties from './cloneSnakeCaseProperties';
export default function getFeature(featureKey, {
  featuresContext = {},
  optimizely = {}
}) {
  const {
    features = {},
    featuresCacheRef = {},
    lastUpdated
  } = featuresContext;

  // return valid cached feature
  if (featuresCacheRef.current) {
    const cachedFeature = featuresCacheRef.current[featureKey];
    if (cachedFeature && cachedFeature.timestamp === lastUpdated) {
      return cachedFeature.value;
    }
  }

  // return updated feature
  let isFeatureEnabled = false;
  let featureVariables = {};
  if (optimizely.isValidFeature(featureKey)) {
    // hydrate feature using optimizely api
    [isFeatureEnabled, featureVariables = {}] = optimizely.getDecision(featureKey);
  } else if (features[featureKey]) {
    const forcedOptimizelyFeatures = optimizely.getForcedFeatures();
    const feature = features[featureKey];
    isFeatureEnabled = feature.enabled;
    featureVariables = feature?.variables || {};
    if (forcedOptimizelyFeatures[featureKey] !== false && forcedOptimizelyFeatures[featureKey] !== undefined) {
      isFeatureEnabled = true;
      featureVariables = {
        ...featureVariables,
        ...forcedOptimizelyFeatures[featureKey]
      };
    } else if (forcedOptimizelyFeatures[featureKey] === false) {
      isFeatureEnabled = false;
      featureVariables = {};
    }
  }

  // duplicate snake_case property featureKeys
  featureVariables = Object.entries(featureVariables).reduce(cloneSnakeCaseProperties, {});
  const featureData = [isFeatureEnabled, featureVariables];

  // cache the feature data locally
  if (featuresCacheRef.current) {
    featuresCacheRef.current[featureKey] = {
      timestamp: lastUpdated,
      value: featureData
    };
  }
  return featureData;
}